import React from 'react';
import { DefaultThemeProvider } from '@ff/ui';

export default function withThemeProvider(Component) {
  const WithThemeProvider = (props) => (
    <DefaultThemeProvider customizedTheme={{ allowHtmlText: true }}>
      <Component {...props} />
    </DefaultThemeProvider>
  );

  return WithThemeProvider;
}
